import { jsx as _jsx } from "react/jsx-runtime";
import { isMatch } from 'lodash-es';
import { createContext, useContext } from 'react';
const ExecutorsContext = createContext({
    executors: [],
});
export function useExecutor(id, variables) {
    const { executors } = useContext(ExecutorsContext);
    const op = getCandidates(id, executors)
        .filter((entry) => matchVariables(entry.variables, variables))
        .pop();
    if (op) {
        if (typeof op.executor === 'function') {
            return (vars) => op.executor(id, vars);
        }
        return op.executor;
    }
    throw new ExecutorRegistryError(executors, id, variables);
}
export function OperationExecutor({ children, ...entry }) {
    const upstream = useContext(ExecutorsContext).executors;
    const merged = mergeExecutors(upstream, [entry]);
    return (_jsx(ExecutorsContext.Provider, { value: {
            executors: merged,
        }, children: children }));
}
function executorMap(executors) {
    return Object.fromEntries(executors.map((ex) => [`${ex.id}:${JSON.stringify(ex.variables)}`, ex]));
}
function mergeExecutors(oldExecutors, newExecutors) {
    return Object.values(Object.assign({}, executorMap(oldExecutors), executorMap(newExecutors)));
}
function matchVariables(matcher, variables) {
    if (typeof matcher === 'undefined') {
        return true;
    }
    if (typeof matcher === 'function') {
        return matcher(variables);
    }
    return isMatch(variables, matcher);
}
function getCandidates(id, registry) {
    return registry.filter((entry) => id === entry.id || entry.id === undefined);
}
function formatEntry(id, variables) {
    return `${id ? id : '*'}:${variables ? JSON.stringify(variables) : '*'}`;
}
class ExecutorRegistryError extends Error {
    constructor(registry, id, variables) {
        const candidates = getCandidates(id, registry);
        const candidatesMessage = candidates.length > 0
            ? [
                'Candidates:',
                ...candidates.map(({ id, variables }) => formatEntry(id, variables)),
            ]
            : [];
        super([
            'No executor found for:',
            formatEntry(id, variables),
            ...candidatesMessage,
        ].join(' '));
        this.name = 'ExecutorRegistryError';
    }
}
